export enum PhoneNumberRequirement {
  tooShort = 'phone-number-too-short',
  invalidCountryCode = 'phone-number-invalid-country-code',
  tooLong = 'phone-number-too-long',
  invalidNumber = 'phone-number-invalid-number',
}
